import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  	isLoading: false,
  	loadingText: 'Loading...',
  	pageTitle: "Home",
  	darkMode: false,
    activeModals: [],
    isSideMenuCollapse: false,
};

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    showLoading: (state, action) => {
        state.isLoading = true;
        state.loadingText = action.payload ?? 'Loading...';
    },
    hideLoading: (state) => {
        state.isLoading = false;
        state.loadingText = 'Loading...';
    },
    switchThemeMode: (state, action) => {
        state.darkMode = action.payload;
    },
    addActiveModal: (state, action) => {
      const modalName = action.payload;
      if (!state.activeModals.includes(modalName)) {
        state.activeModals.push(modalName);
      }
    },
    removeActiveModal: (state, action) => {
      const modalName = action.payload;
      state.activeModals = state.activeModals.filter(name => name !== modalName);
    },
    toggleSideMenu: (state, action) => {
      console.log(action.payload);
      state.isSideMenuCollapse = action.payload;
    },
  },
})

export const { 
    showLoading, hideLoading, switchThemeMode,
    addActiveModal, removeActiveModal,
    toggleSideMenu
} = layoutSlice.actions

export default layoutSlice.reducer